
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thriftyadvice/contact-us",
      function () {
        return require("private-next-pages/thriftyadvice/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thriftyadvice/contact-us"])
      });
    }
  